
import { useState, useEffect } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CTASection } from "@/components/CTASection";
import { HeroSection } from "@/components/sections/HeroSection";
import { FeaturesSection } from "@/components/sections/FeaturesSection";
import { AboutSection } from "@/components/sections/AboutSection";
import { ServicesSection } from "@/components/sections/ServicesSection";
import { TeamSection } from "@/components/sections/TeamSection";
import { TestimonialsSection } from "@/components/sections/TestimonialsSection";
import { ContactSection } from "@/components/sections/ContactSection";
import { PageTitle } from "@/components/PageTitle";
import { SchemaMarkup } from "@/components/SchemaMarkup";

const Index = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className={`min-h-screen transition-opacity duration-500 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
      <PageTitle title="Asrani Dental – Best Dentist | Best Root Canal | Aligners | Invisalign | Nagpur" />
      <SchemaMarkup />
      <Header />
      
      <HeroSection />
      
      <FeaturesSection />
      
      <AboutSection />
      
      <ServicesSection />
      
      <CTASection 
        title="Ready to Transform Your Smile?" 
        description="Schedule your consultation today and take the first step towards the healthy, beautiful smile you deserve." 
        primaryButtonText="Book an Appointment" 
        secondaryButtonText="Contact Us" 
        primaryButtonLink="/dental-appointment-booking"
        secondaryButtonLink="/contact"
      />
      
      <TeamSection />
      
      <TestimonialsSection />
      
      <ContactSection />
      
      <Footer />
    </div>
  );
};

export default Index;
